import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ShopService from "../../services/ShopService";

const EditShop = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const initialShopState = {
    id: null,
    name: "",
    opendays: "",
    open_close_time: "",
    phone: "",
    email: "",
    address: "",
    description: "",
    image: null,
    published: false,
  };
  const [currentShop, setCurrentShop] = useState(initialShopState);
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const getShop = (id) => {
    ShopService.get(id)
      .then((response) => {
        setCurrentShop(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (id) getShop(id);
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentShop({ ...currentShop, [name]: value });
  };

  const handleImageInputChange = (e) => {
    const { name, value } = e.target;
    const inputimage = e.target.files[0];
    setCurrentShop({ ...currentShop, [name]: inputimage });
  };

  const updateShop = () => {
    ShopService.update(currentShop.id, currentShop)
      .then((response) => {
        setMessage("The Shop was updated successfully!");
        setSubmitted(true);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const deleteShop = () => {
    ShopService.remove(currentShop.id)
      .then((response) => {
        console.log(response.data);
        navigate("/Shop");
      })
      .catch((e) => {
        setMessage("Error: " + e.response.data.message);
        setSubmitted(true);
      });
  };

  return (
    <>
      <div className="container pb-10">
        {currentShop ? (
          <>
            <h1 className="text-1xl lg:text-1xl font-semibold py-10">
              {" "}
              Edit {currentShop.name}
            </h1>
            <div>
              {submitted ? (
                <div
                  className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
                  role="alert"
                >
                  <p style={{ marginBottom: "0" }}>{message}</p>
                </div>
              ) : (
                <>
                  <p style={{ marginBottom: "0" }}>{message}</p>
                </>
              )}
              <br></br>
            </div>

            <form className="w-full">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Shop Name
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="name"
                    name="name"
                    type="text"
                    value={currentShop.name}
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="md:flex md:items-center mb-6">
                <div className="md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Shop Open Days
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="opendays"
                    name="opendays"
                    type="text"
                    value={currentShop.opendays}
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="md:flex md:items-center mb-6">
                <div className="md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Shop Open Close Time
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="open_close_time"
                    name="open_close_time"
                    type="text"
                    value={currentShop.open_close_time}
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="md:flex md:items-center mb-6">
                <div className="md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Shop Phone
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="phone"
                    name="phone"
                    type="text"
                    value={currentShop.phone}
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="md:flex md:items-center mb-6">
                <div className="md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Shop Email
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="email"
                    name="email"
                    type="text"
                    value={currentShop.email}
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="md:flex md:items-center mb-6">
                <div className="md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Shop Address
                  </label>
                </div>
                <div className="md:w-2/3">
                  <textarea
                    rows="4"
                    className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="address"
                    name="address"
                    type="text"
                    value={currentShop.address}
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="md:flex md:items-center mb-6">
                <div className="md:w-1/3">
                  <label
                    className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    About Shop
                  </label>
                </div>
                <div className="md:w-2/3">
                  <textarea
                    rows="10"
                    className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="description"
                    name="description"
                    type="text"
                    value={currentShop.description}
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="md:flex md:items-center mb-6">
                <div className="md:w-1/3">
                  <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
                    Image
                  </label>
                </div>
                <div className="md:w-2/3">
                  <input
                    className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    type="file"
                    id="image"
                    onChange={handleImageInputChange}
                    name="image"
                  />
                </div>
              </div>
            </form>

            <div className="md:flex md:items-center">
              <div className="md:w-1/3"></div>
              <div className="md:w-2/3 grid grid-cols-2 gap-40">
                <span></span>

                <button
                  className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="submit"
                  onClick={updateShop}
                >
                  Update
                </button>
              </div>
            </div>
          </>
        ) : (
          <div>
            <br />
            <p>Please click on a Shop...</p>
          </div>
        )}
      </div>
    </>
  );
};

export default EditShop;
